import * as React from "react";
import { ChakraProvider, Container, Flex, Box } from "@chakra-ui/react";
import theme from "./theme";
import ScoreOverview from "./components/ScoreOverview";
import Navigation from "./components/Navigation";
import Header from "./components/Header";
import Countdown from "react-countdown";
import moment from "moment";
import CountdownView from "./components/CountdownView";
import useAuth from "./hooks/useAuth";
import { Auth } from "aws-amplify";
import OnboardingModal from "./components/OnboardingModal";
import { NotificationContextProvider } from "./context/notificationContext";

const ROSES_START_DATE = moment("2026-05-01").toDate();

Auth.configure({
  identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  region: process.env.REACT_APP_COGNITO_REGION,
  identityPoolRegion: process.env.REACT_APP_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
    scope: ["profile", "email", "openid"],
    redirectSignIn: process.env.REACT_APP_REDIRECT_URL,
    redirectSignOut: "https://weblogin.lancs.ac.uk/logout",
    responseType: "token",
  },
  authenticationFlowType: "USER_SRP_AUTH",
  mandatorySignIn: true,
});

export const App = () => {
  const { authenticated } = useAuth();

  return (
    <ChakraProvider theme={theme}>
      <NotificationContextProvider>
        <OnboardingModal />
        <Container textAlign="center" fontSize="xl">
          <Flex minH="100vh" p={5} alignItems="center" direction="column">
            <Header />
            <Box mt={170} w="full">
              <Countdown
                date={ROSES_START_DATE}
                renderer={({ days, hours, minutes, seconds, completed }) => {
                  if (completed) return <ScoreOverview />;
                  return (
                    <CountdownView
                      days={days}
                      hours={hours}
                      minutes={minutes}
                      seconds={seconds}
                    />
                  );
                }}
              />
              <Navigation />
            </Box>
          </Flex>
        </Container>
      </NotificationContextProvider>
    </ChakraProvider>
  );
};
